import Vue from "vue";
import Vuex from "vuex";
// 数据持久化
import createPersistedState from "vuex-persistedstate";
//仓库模块
import modules from "./modules";
//仓库getter
import getters from "./getters/index";
Vue.use(Vuex);

export default new Vuex.Store({
  modules,
  getters,
  state: {},
  mutations: {},
  actions: {},
  plugins: [
    createPersistedState({
      key: "Store",
      storage: window.sessionStorage,
      reducer(val) {
        return {
          game: val.game
        };
      }
    })
  ]
});
